import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { StreamDestinationsFiltersBuilder } from "@graylog/server-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const fetchRuleConditions = async () => StreamDestinationsFiltersBuilder.getConditions().then((resp) => resp.conditions);
export const fetchValidateRule = async (currentRule) => {
  const { stream_id, destination_type, status, source, rule: rule_builder, ...ruleToValidate } = currentRule;
  return StreamDestinationsFiltersBuilder.validateRule({ rule_builder, ...ruleToValidate }).then(
    (resp) => {
      const {
        rule_builder: { rule_builder: rule, ...validRule }
      } = resp;
      return { ...currentRule, rule, ...validRule };
    }
  );
};
const useStreamOutputRuleBuilder = () => {
  const {
    data: conditions,
    refetch: refetchConditions,
    isFetching: isLoadingConditions
  } = useQuery({
    queryKey: ["stream", "filter", "conditions"],
    queryFn: () => defaultOnError(
      fetchRuleConditions(),
      i18n.t("stream_hooks.load_rule_builder_failed", { ns: "streams" }),
      i18n.t("stream_hooks.load_rule_builder_failed_title", { ns: "streams" })
    ),
    placeholderData: keepPreviousData
  });
  return {
    conditions,
    refetchConditions,
    isLoadingConditions
  };
};
export default useStreamOutputRuleBuilder;
